import {
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React, { FC, useCallback, useEffect, useState } from 'react';
import PageTitle from '../../components/PageTitle';
import { Footer } from '../../components/Footer';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../services/redux/store';
import ClubNewItem from './components/ClubNewItem';
import { Button } from '../../components/Button';
import { STYLE_VARS } from '../../constants/style-vars';
import { Image } from '../../components/Image';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import NewLayout from '../../WebLayout/NewLayout/NewLayout';
import { COLORS, FONTS } from '../../constants';
import { IS_WEB } from '../../constants/platform';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { newspaper_icon } from '../../assets/base64';
import { INewsCategory } from '../../types';
import { NewApi } from '../../services/api';
import { Loading } from '../../components';
import {
  NewsFilter,
  clearNewsFilter,
  setLoadingNews,
  setNews,
  setNewsFilter,
  setTotal,
} from '../../services/redux/reducers/NewsSlice';
import Filter from '../../components/Filter/Filter';
import { Category } from '../../types/categories.types';

const ClubNews: FC = () => {
  const isDesktop = useIsDesktop();
  const dispatch = useDispatch();

  const [toggleFilter, setToggleFilter] = useState<boolean>(false);
  const [filterSelected, setFilterSelected] = useState<Category[]>([]);

  const { newsFilter, newsData, total, isLoading } = useSelector(
    (state: RootState) => state.newsReducer
  );

  const getNews = useCallback(
    async (props: NewsFilter) => {
      try {
        dispatch(setLoadingNews(true));
        const res = await NewApi.getNews(props);
        dispatch(setNews(res.data.news));
        dispatch(setTotal(res.data.total));
      } catch (error: any) {
        console.log(error);
      } finally {
        dispatch(setLoadingNews(false));
      }
    },
    [dispatch]
  );

  const handleLoadmore = useCallback(async () => {
    if (newsData.length < total) {
      dispatch(
        setNewsFilter({
          ...newsFilter,
          page: Math.ceil(newsData.length / 6) + 1,
        })
      );
      try {
        dispatch(setLoadingNews(true));
        const res = await NewApi.getNews({
          ...newsFilter,
          page: Math.ceil(newsData.length / 6) + 1,
        });
        dispatch(setNews([...newsData, ...res.data.news]));
        dispatch(setTotal(res.data.total));
      } catch (error: any) {
        console.log(error);
      } finally {
        dispatch(setLoadingNews(false));
      }
    }
  }, [newsData, total, dispatch, newsFilter]);

  useEffect(() => {
    dispatch(clearNewsFilter());
    getNews({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [newsCategories, setNewsCategories] = useState<INewsCategory[]>([]);

  const getNewsCategoriesData = useCallback(async () => {
    try {
      const res = await NewApi.getNewsCategories({});
      setNewsCategories(res.data);
    } catch (error: any) {
      console.log(error);
    } finally {
    }
  }, []);

  useEffect(() => {
    getNewsCategoriesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isDesktop()) {
    return (
      <NewLayout
        title="Club News"
        icon={
          IS_WEB
            ? addBase64Prefix(newspaper_icon)
            : require('../../assets/newspaper-icon.png')
        }
      >
        <View style={styles.newWrapper}>
          {newsData.map((newItem) => (
            <View
              style={{ width: '50%', paddingEnd: 60, alignSelf: 'stretch' }}
              key={newItem.id}
            >
              <ClubNewItem item={newItem} key={newItem.id} />
            </View>
          ))}
        </View>
        {isLoading === false && newsData.length === 0 ? (
          <View style={styles.noDataWrapper}>
            <Text style={[styles.noDataText, { fontSize: 20 }]}>
              THERE ARE CURRENTLY NO NEWS
            </Text>
          </View>
        ) : (
          <></>
        )}
        {isLoading && <Loading style={{ paddingVertical: 30 }} />}
        {total > newsData.length && (
          <View style={{ marginHorizontal: 'auto' }}>
            <Button
              style={STYLE_VARS.blueButton}
              text="VIEW MORE"
              onPress={handleLoadmore}
              disabled={isLoading}
            />
          </View>
        )}
      </NewLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="Club News"
          icon={require('../../assets/news.png')}
          haveGoBackButton={true}
        />
      </View>
      <View style={[styles.container, { zIndex: 5 }]}>
        <TouchableOpacity
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            alignSelf: 'flex-start',
            marginVertical: 20,
          }}
          onPress={() => setToggleFilter(!toggleFilter)}
        >
          <Text
            style={{
              fontFamily: FONTS.IowanOldStyleBTRoman,
              fontSize: 16,
              fontWeight: '500',
              color: STYLE_VARS.textColor,
              textTransform: 'uppercase',
              letterSpacing: 1,
            }}
          >
            Filter
          </Text>
          <Image
            source={require('../../assets/filter-button.png')}
            style={{
              width: 15,
              height: 15,
              resizeMode: 'contain',
              tintColor: STYLE_VARS.primaryColor,
              marginLeft: 5,
            }}
          />
        </TouchableOpacity>
        {toggleFilter && (
          <Filter
            categoriesData={newsCategories}
            getData={getNews}
            filterData={newsFilter}
            setFilterData={setNewsFilter}
            setData={setNews}
            filterSelected={filterSelected}
            setFilterSelected={setFilterSelected}
          />
        )}
      </View>
      <View style={styles.container}>
        {newsData.map((newItem) => (
          <ClubNewItem item={newItem} key={newItem.id} />
        ))}
      </View>
      {isLoading === false && newsData.length === 0 ? (
        <View style={styles.noDataWrapper}>
          <Text style={[styles.noDataText, { fontSize: 16 }]}>
            THERE ARE CURRENTLY NO NEWS
          </Text>
        </View>
      ) : (
        <></>
      )}
      {isLoading && <Loading style={{ paddingVertical: 30 }} />}
      {total > newsData.length && (
        <View style={{ paddingVertical: 40 }}>
          <Button
            style={STYLE_VARS.blueButton}
            text="VIEW MORE"
            onPress={handleLoadmore}
            disabled={isLoading}
          />
        </View>
      )}
      <Footer />
    </ScrollView>
  );
};

export default ClubNews;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  navbarWrapper: {
    width: '40%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    alignSelf: 'flex-start',
  },
  newWrapper: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    marginBottom: 35,
  },
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 20,
  },
  noDataText: {
    color: COLORS.GREEN,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
  },
});
